
export class FrontendWorkflowActivityDefinition {
    name = "*";
    allowSaveButton = true;
    deleteOnCancel = false;
}
